'use client';

import React from 'react';
import ComboBox from './ComboBox';
import type { ComboBoxProps } from './comboBox.types';

const ComboBoxMulti: React.FC<Partial<ComboBoxProps>> = (props) => {
  const typed = props as Partial<ComboBoxProps>;
  return <ComboBox {...typed} items={typed.items ?? []} multi />;
};

export default ComboBoxMulti;
